import { formatPKR } from './currencyFormatter';

/**
 * Party ledger: positive = they owe us (to receive), negative = we owe them.
 */
export function partySearchBalanceClassName(balance, isShopExpense = false) {
  if (isShopExpense) return 'party-search-balance party-search-balance--zero';
  const num = parseFloat(balance);
  if (Number.isNaN(num) || num === 0) return 'party-search-balance party-search-balance--zero';
  if (num > 0) return 'party-search-balance party-search-balance--receive';
  return 'party-search-balance party-search-balance--pay';
}

export function formatPartySearchBalanceLabel(balance, isShopExpense = false) {
  if (isShopExpense) return 'Expense ledger';
  const num = parseFloat(balance) || 0;
  if (num > 0) return `${formatPKR(num)} (To receive)`;
  if (num < 0) return `${formatPKR(Math.abs(num))} (We owe)`;
  return formatPKR(0);
}
